module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e105"
    }
  }, [_vm._v("This book is dedicated with love and gratitude "), _c('br'), _vm._v("to our Women of Faith intercessor, Lana Bateman. "), _c('br'), _vm._v("You have taught me so much about living a "), _c('br'), _vm._v("life of prayer, and I thank our Father for you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6cfcb5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wals_ISBN1418537640_epub_c3_r1.vue
// module id = 63
// module chunks = 0